import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Project } from 'src/app/models/project';

@Component({
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss']
})
export class ProjectCardComponent{

  @Input() projects: Project[] = [];
  @Output() projectSelected: EventEmitter<Project>;

  constructor(){
    this.projectSelected = new EventEmitter();
  }

  showModal( project:Project ){
    this.projectSelected.emit( project );
  }
  
}
